<template>
  <div class="pricing-manager-container">

    <el-card class="box-card"  v-loading.fullscreen.lock="loading">
      <sticky :z-index="10" class-name="submit-area" v-if="editRole">
          <el-select v-model="currency" placeholder="Select" @change="load">
          <el-option
            v-for="item in currencyLists"
            :key="item.uid"
            :label="item.currency.toUpperCase()"
            :value="item.uid">
          </el-option>
        </el-select>
        <el-button style="margin-left: 10px;" icon="el-icon-copy-document" type="success" @click="cloneCost()">
          Clone
        </el-button>
        <el-button style="margin-left: 10px;" :loading="submiting" type="primary" @click="submitCost()">
          Submit
        </el-button>
      </sticky>
      <el-checkbox v-model="selectAll" @change="activeAll"  v-if="editRole"
        >Select All</el-checkbox
      >
      <div class="cost-list" v-for="(pricing, index) in pricingLists" :key="index">
       
        <el-table
        border
          stripe
          :data="pricing.pricings"
          style="width: 100%">
          <el-table-column
            prop="active"
            label="Active"
            width="80"
            header-align="center" align="center" fixed>
            <template slot-scope="scope">
              <span v-if="readRole && pricingLists[index].pricings[scope.$index].active"><i class="el-icon-circle-check"></i></span>
              <el-checkbox v-model="pricingLists[index].pricings[scope.$index].active" @change="activeCost" v-if="!readRole"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column header-align="center"  :width="readRole ? '' : '320'" fixed>
              <template slot="header">
                {{ pricing.header_text }}
              </template>
              <template slot-scope="scope">
                {{ scope.row.text }}
              </template>
          </el-table-column>
        <el-table-column label="Fee Collect from customer" header-align="center">
          <el-table-column
            prop="cost"
            label="Cost"
            header-align="center"
            align="center"
            width="120"
            >
            <template slot-scope="scope">
              <span v-if="readRole">{{ pricingLists[index].pricings[scope.$index].cost }}</span>
              <el-input type="number" size="mini" v-model="pricingLists[index].pricings[scope.$index].cost" v-if="!readRole"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="currency"
            label="Currency"
            header-align="center"
            align="center"
            width="120"
            >
            <template slot-scope="scope">
              <span v-if="readRole">{{ pricingLists[index].pricings[scope.$index].currency }}</span>
              <el-select size="mini" v-model="pricingLists[index].pricings[scope.$index].currency" placeholder="Select" v-if="!readRole">
                <el-option label="GBP" value="GBP"></el-option>
                <el-option label="EUR" value="EUR"></el-option>
                <el-option label="USD" value="USD"></el-option>
              </el-select>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="is_percent"
            label="Is percent"
            width="80"
            header-align="center" align="center">
            <template slot-scope="scope">
              <span v-if="readRole && pricingLists[index].pricings[scope.$index].is_percent"><i class="el-icon-circle-check"></i></span>
              <el-checkbox v-model="pricingLists[index].pricings[scope.$index].is_percent"  v-if="!readRole"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="percent"
            label="Percent"
            header-align="center"
            align="center"
            width="120"
            >
            <template slot-scope="scope">
              <span v-if="readRole">{{ pricingLists[index].pricings[scope.$index].percent }}</span>
              <el-input size="mini" v-model="pricingLists[index].pricings[scope.$index].percent"  v-if="!readRole"></el-input>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="Fee collect from agent (under whitelable)" header-align="center">
           <el-table-column
            prop="system_fee"
            label="Fee"
            header-align="center"
            align="center"
            width="100"
            v-if="editRole"
          >
            <template slot-scope="scope">
              <el-input
                type="number"
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].system_fee"
              ></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="system_fee_currency"
            label="Fee Currency"
            header-align="center"
            align="center"
            width="100"
            v-if="editRole"
          >
            <template slot-scope="scope">
              <el-select
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].system_fee_currency"
                placeholder="Select"
              >
                <el-option label="GBP" value="GBP"></el-option>
                <el-option label="EUR" value="EUR"></el-option>
                <el-option label="USD" value="USD"></el-option>
              </el-select>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="fee_ispercent"
            label="Fee Is %"
            width="80"
            header-align="center"
            align="center"
            v-if="editRole"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="pricingLists[index].pricings[scope.$index].system_fee_ispercent"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="system_fee_percent"
            label="Fee %"
            header-align="center"
            align="center"
            width="100"
            v-if="editRole"
          >
            <template slot-scope="scope">
              <el-input
              type="number"
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].system_fee_percent"
              ></el-input>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="Introducer share benefit" header-align="center">
           <el-table-column
            prop="introducer_share"
            label="Share"
            header-align="center"
            align="center"
            width="100"
            v-if="editRole"
          >
            <template slot-scope="scope">
              <el-input
                type="number"
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].introducer_share"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="introducer_share_ispercent"
            label="Is %"
            width="80"
            header-align="center"
            align="center"
            v-if="editRole"
          >
            <template slot-scope="scope">
              <el-checkbox
                v-model="pricingLists[index].pricings[scope.$index].introducer_share_ispercent"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            prop="introducer_share_percent"
            label="Percent"
            header-align="center"
            align="center"
            width="100"
            v-if="editRole"
          >
            <template slot-scope="scope">
              <el-input
              type="number"
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].introducer_share_percent"
              ></el-input>
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column label="Transaction name on statement" header-align="center">
          <el-table-column
            prop="fee_text"
            label="Fee Text"
            header-align="center"
            align="center"
            width="220"
            v-if="editRole"
          >
            <template slot-scope="scope">
              <span v-if="readRole">{{ pricingLists[index].pricings[scope.$index].fee_text }}</span>
              <el-input
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].fee_text"
                v-if="!readRole">
              ></el-input>
            </template>
          </el-table-column>
        </el-table-column>

          <el-table-column
            prop="railsbank_code"
            label="Code"
            header-align="center"
            align="center"
            width="220"
            v-if="editRole"
          >
            <template slot-scope="scope">
              <span v-if="readRole">{{ pricingLists[index].pricings[scope.$index].railsbank_code }}</span>
              <el-input
                size="mini"
                v-model="pricingLists[index].pricings[scope.$index].railsbank_code"
                v-if="!readRole"
              ></el-input>
            </template>
          </el-table-column>
        </el-table>
         <el-divider content-position="left"></el-divider>
      </div>
    </el-card>

    <el-dialog title="Clone Pricing" :visible.sync="dialogFormVisible">
      <el-form ref="cloneForm" :model="cloneForm" :rules="cloneFormRole" label-width="120px" size="mini">
          <el-form-item prop="companySelect" label="Company">
            <el-select v-model="cloneForm.companySelect" @change="getProjectData()">
              <el-option v-for="item of companyLists" :key="item.uid" :label="item.company_name" :value="item.uid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="from_project_uid" label="Project">
            <el-select v-model="cloneForm.from_project_uid" :loading="loadingProject" @change="getCurrencyForm()">
              <el-option v-for="item of projectLists" :key="item.uid" :label="item.project_name" :value="item.uid" :disabled="item.uid === projectUID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="from_currency_uid" label="Currency">
            <el-select v-model="cloneForm.from_currency_uid" :loading="loadingProject" @change="getCurrencyForm()">
              <el-option v-for="item of currencyFromLists" :key="item.uid" :label="item.currency.toUpperCase()" :value="item.uid" :disabled="item.uid === projectUID"></el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="submitingClone" type="primary" @click="submitClone()" :disabled="!checkSubmit">Submit</el-button>
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sticky from '@/components/Sticky'
import { getCurrencyList } from '@/api/currency'
import { getPricing, updatePricing, clonePricing } from '@/api/pricing'
import {getCompany} from "@/api/company";
import {getProjectByCompany} from '@/api/project'
import { findObjectArray } from "@/utils";
export default {
  components: { Sticky },
  props:{
    projectUID: String
  },

  computed:{
    editRole(){
      return this.roleAuth([this.role.spadmin])
    },
    readRole(){
      return this.roleAuth([this.role.admin])
    },
    checkSubmit(){
      return this.cloneForm.from_project_uid && this.cloneForm.from_currency_uid
    }
  },
  data(){
    return{
      loading: false,
      pricingLists:[],
      submiting: false,
      dialogFormVisible: false,
      loadingProject: false,
      submitingClone: false,
      companyLists: [],
      projectLists:[],
      selectAll: false,
      cloneForm:{
        from_project_uid: '',
        companySelect: '',
        from_currency_uid: ''
      },
      cloneFormRole:{
        from_project_uid: [{required: true, message: 'Please select project to clone pricing'}],
        companySelect: [{required: true, message: 'Please select company'}],
      },
      currencyLists:[],
      currency: "",
      currencyFromLists: []
    }
  },
  methods:{
    getPricingList(currency){
      this.pricingLists = []
      if(!currency) return false
      this.loading = true
      getPricing(this.projectUID, currency).then(({result, data}) =>{
        this.loading = false
        if(result && data){
          this.pricingLists = data
          this.activeCost()
        }
      })
    },
    getCompanyList(){
      const loading = this.$notifyloading("Loading data...");
      getCompany().then(({result, data})=>{
        loading.close()
        if(result && data){
          this.companyLists = data
          this.dialogFormVisible = true
        }
      })
    },
    getCurrencyList(){
      getCurrencyList(this.projectUID).then(({result, data})=>{
        if(result && data){
          this.currencyLists = data
        }
      })
    },
    getProjectData(){
      this.loadingProject = true
      this.cloneForm.from_project_uid = ''
      getProjectByCompany(this.cloneForm.companySelect).then(({result, data}) =>{
        this.loadingProject = false
        if(result){
          this.projectLists = data
        }
      })
    },
    getCurrencyForm(){
      getCurrencyList(this.cloneForm.from_project_uid).then(({result, data})=>{
        if(result && data){
          this.currencyFromLists = data
        }
      })

    },

    mapData(){
      const formData = {
        pricings:[]
      }

      this.pricingLists.forEach(group =>{
        group.pricings.forEach( item=>{
          formData.pricings.push({
            pricing_group: item.pricing_group,
            pricing_code: item.pricing_code,
            text: item.text,
            cost: item.cost,
            currency: item.currency,
            is_percent: item.is_percent,
            percent: item.percent,
            active: item.active,
            fee_text: item.fee_text,
            system_fee: item.system_fee,
            system_fee_currency: item.system_fee_currency,
            system_fee_ispercent: item.system_fee_ispercent,
            system_fee_percent: item.system_fee_percent,
            railsbank_code: item.railsbank_code,
            introducer_share: item.introducer_share,
            introducer_share_ispercent: item.introducer_share_ispercent,
            introducer_share_percent: item.introducer_share_percent

          })
        })
      })

      return formData
    },
    submitCost(){
      const formData = this.mapData()
      this.submiting = true
      updatePricing(this.projectUID, this.currency, formData).then(({result})=>{
        this.submiting = false
        if(result){
          this.$notify({
                title: 'Success',
                message: `Update Pricing successfully`,
                type: 'success',
                duration: 2000
              });
        }
      })
    },
    cloneCost(){
      if(this.$refs.cloneForm) this.$refs.cloneForm.resetFields()
      this.getCompanyList()
    },
    submitClone(){
      this.$refs.cloneForm.validate((valid) => {
        if(valid){
          this.submitingClone = true
          
          clonePricing(this.projectUID, this.currency, this.cloneForm).then(({result})=>{
            this.submitingClone = false
            if(result){
              this.dialogFormVisible = false
              this.$router.go(0)
            }
          })
        }
      })
      
    },
    activeCost() {
      var activeAll = 0;
      var actived = 0;

      this.pricingLists.forEach((group) => {
        activeAll += group.pricings.length;
        actived += findObjectArray(group.pricings, true, "active").length;
      });

      this.selectAll = activeAll === actived ? true : false;
    },
    activeAll(value) {
      this.pricingLists.forEach((group) => {
        group.pricings.forEach((item) => {
          item.active = value;
        });
      });
    },

    load(currency){
      this.getPricingList(currency)
      this.currency = currency
      //if(!this.$route.query.currency){
        this.$router.push('?tab=price&currency='+currency)
      //}
    }
  },
  created(){
    let currency = this.$route.query.currency
    this.getCurrencyList()
    this.getPricingList(currency)
    this.currency = currency

  }
}
</script>

<style lang="scss">
.pricing-manager-container{
  .cost-list{
    display: block;
  }

  .el-card__body {
      padding-top:5px;
      min-height: 200px;
  }

  .submit-area{
    background-color: white;
    height: 55px;
    line-height: 55px;
    position: relative;
    width: 100%;
    text-align: right;
  }


  table td:nth-child(6),
  table td:nth-child(7),
  table td:nth-child(8),
  table td:nth-child(14),
  table td:nth-child(15){
    background: #eaf5ff !important;
  }

  table td:nth-child(9),
  table td:nth-child(10),
  table td:nth-child(11){
    background: #ddffe3 !important;  
  }

  table thead tr:nth-child(1) th:nth-child(5),
  table thead tr:nth-child(2) th:nth-child(7),
  table thead tr:nth-child(2) th:nth-child(8),
  table thead tr:nth-child(2) th:nth-child(9){
    background: #ecffe2 !important;  
  }

}

</style>